<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
	>
		<template>
			<input class="form-field__input"
			       :class="[inputClass, (fieldValue || inputFocus) ? 'is-fill' : '', isError ? 'error' : '']"
			       type="email"
			       autocomplete="off"
			       v-validate="rules"
			       :data-vv-as="fieldProps.TITLE"
				   :placeholder="fieldProps.PLACEHOLDER"
			       :name="fieldProps.CODE"
			       :value="fieldValue"
			       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
			       :disabled="disable"
			       @input="changeValue"
			       @focus="labelSwitch('focus')"
			       @blur="labelSwitch">
		</template>
	</form-field-wrap>
</template>
<script>
	export default {
		name: "FormFieldEmail",
		computed: {
			rules() {
				let arRules = [];
				if (this.fieldProps.REQUIRED == "Y") {
					arRules.push('required');
				}

				if (this.fieldProps.RULES) {
					arRules = arRules.concat(this.fieldProps.RULES);
				}

				arRules.push('email');

				let stRules = arRules.join('|');
				return stRules;
			},
		},
	};
</script>